module.exports = __webpack_public_path__ + "img/air.ae89dbc8.png";